
import axios from 'axios';
import React, { useState } from 'react';
import Navigation from '../components/Navigation';
// import { FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import base_url from '../config/Config';
// import { AiFillFile } from "react-icons/ai";
import Sidebar from '../components/Sidebar';
import Cookies from 'js-cookie';


const AddProduct = () => {
    const navigate = useNavigate();
    const token = Cookies.get('authToken');
    const [formData, setFormData] = useState({
        productName: '',
        interestRate: '',
        interestRateType: '',
        processFee: '',
        otherDeduction: '',
        loanAmount: '',
        tenureInDays: '',
        repaymentType: '',
        numberOfEmi: '',
        productType: '',

    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            console.log('Form Data:', formData);

            // Make an API request to save data
            const response = await axios.post(`${base_url}/api/product/addProduct`, {
                headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
                productName :formData.productName,
                interestRate :formData.interestRate,
                interestRateType: formData.interestRateType,
                processFee: formData.processFee,
                otherDeduction:formData.otherDeduction,
                loanAmount: formData.loanAmount,
                tenureInDays: formData.tenureInDays,
                repaymentType: formData.repaymentType,
                numberOfEmi: formData.numberOfEmi,
                productType: formData.productType,

            });

            console.log('API Response:', response.data);

            // Handle the response as needed (e.g., show success message)
            window.alert('Add Customer successfully');

            // Optionally, you can reset the form after successful submission
            setFormData({
       productName: '',
        interestRate: '',
        interestRateType: '',
        processFee: '',
        otherDeduction: '',
        loanAmount: '',
        tenureInDays: '',
        repaymentType: '',
        numberOfEmi: '',
        productType: '',  

            });

            // Redirect to the list page
            navigate('/loanmaster/Product');
        } catch (error) {
            // Handle errors (e.g., show error message)
            console.error('Error saving data:', error);
        }
    };


    return (
        <>
            <div className='overviewsaa'>
                <h4>Add Customer</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <hr />
                                {/* Personal Details start  */}
                                
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'>
                                        {/* <p>Personal Details</p> */}
                                    </div>
                                <div className='dashboardlms mt-3'>
                                <form action="" onSubmit={handleSubmit}>
                                    <div className='row'>
                                    <div className='col-md-12'>
                                                        <div className='row'>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="productName">Product Name</label><br />
                                                                    <input type="text" name="productName" id="productName" placeholder='Product Name' onChange={handleInputChange} />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="interestRate">Interest Rate</label><br />
                                                                    <input type="text" name="interestRate" id="interestRate" placeholder='Interest Rate' onChange={handleInputChange}/>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="interestRateType">Interest Rate Type</label><br />
                                                                    <input type="text" name="interestRateType" id="interestRateType"  placeholder='Interest Rate Type' onChange={handleInputChange}/>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="processFee">Process Fee</label><br />
                                                                    <input type="text" name="processFee" id="processFee" placeholder='Process Fee'onChange={handleInputChange} />
                                                                </div>
                                                            </div>

                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="partner_loan">Other Deduction</label><br />
                                                                    <input type="text" name="otherDeduction" id="otherDeduction"  placeholder='Other Deduction'onChange={handleInputChange} />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="loanAmount">Loan Amount</label><br />
                                                                    <input type="text" name="loanAmount" id="loanAmount"  placeholder='Loan Amount' onChange={handleInputChange}/>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="tenureInDays">Tenure In Days</label><br />
                                                                    <input type="text" name="tenureInDays" id="tenureInDays"  placeholder='Tenure In Days' onChange={handleInputChange} />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="repaymentType">Repayment Type</label><br />
                                                                    <input type="text" name="repaymentType" id="repaymentType" placeholder='Repayment Type' onChange={handleInputChange}/>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="numberOfEmi">Number Of EMI</label><br />
                                                                    <input type="text" name="numberOfEmi" id="numberOfEmi"  placeholder='Number Of EMI' onChange={handleInputChange} />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-3 col-lg-3'>
                                                                <div className='personaldetails text-justify mt-3'>
                                                                    <label htmlFor="productType">Product Type</label><br />
                                                                    <input type="text" name="productType" id="productType"  placeholder='Product Type' onChange={handleInputChange}/>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12 col-lg-12'>
                                                                <div className='buttonss  mb-5 mt-5 text-center'>
                                                                    <button type='submit'>Save</button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                </div>
                        </div>
                        </form>
                        </div>
                        
                    </div>
                    
                </div>
               
        </div>
        </div>
        </div>
        </div> 
        </>
    );
};

export default AddProduct;
